export const TYPES = {
  ImportCSVApiService: Symbol.for('ImportCSVApiService'),
  ImportCSVUploadRepository: Symbol.for('ImportCSVUploadRepository'),
  ImportCSVUseCases: Symbol.for('ImportCSVUseCases'),
  ImportAbortController: Symbol.for('ImportAbortController'),
};
